module.exports = __webpack_public_path__ + "img/survey-badge-new.f93e890d.jpg";